import Slider from "rc-slider";
import "rc-slider/assets/index.css";
import styles from "./Slider.module.scss";

const sliderStyle = {
	railStyle: {
		backgroundColor: "#BCD2FB",
		height: "8px",
	},
	responsiveRailStyle: {
		backgroundColor: "#BCD2FB",
		height: "6px",
	},
	trackStyle: {
		backgroundColor: "#6371DE",
		height: "8px",
		border: "none",
	},
	responsiveTrackStyle: {
		backgroundColor: "#6371DE",
		height: "6px",
		border: "none",
	},
	handleStyleMobile: {
		zIndex: "21",
		top: "-5px",
		width: `35px`,
		height: `35px`,
		background: `#6371DE`,
		borderRadius: `50%`,
		boxSizing: `border-box`,
		transition: `all 0ms ease 0s`,
		border: "4px solid #FFFFFF",
		boxShadow: "0px 0px 2px rgba(35, 40, 79, 0.2), -1px 2px 6px rgba(35, 40, 79, 0.3)",
	},
};

function SettingsSlider({ id = "", value, onChange, step, min, max, isAdaptive, disabled = false }) {
	const handleScale = (e) => {
		if (e < min || e > max) return;
		onChange(e);
	};
	return (
		<div id={id} className={`${styles.slider_wrapper} rc-slider ${disabled ? styles.disabled : styles.enable}`}>
			<Slider
				startPoint={min - max * 0.02}
				min={min - max * 0.01}
				max={max + max * 0.01}
				step={step}
				defaultValue={value}
				railStyle={isAdaptive ? sliderStyle.responsiveRailStyle : sliderStyle.railStyle}
				trackStyle={isAdaptive ? sliderStyle.responsiveTrackStyle : sliderStyle.trackStyle}
				handleStyle={sliderStyle.handleStyleMobile}
				value={value}
				onChange={handleScale}
				disabled={disabled}
			/>
		</div>
	);
}

export { SettingsSlider };
